import { ReactiveController } from 'lit';
import {
  IntegrationsMarketplaceHistoryLogsWebComponent
} from "../component/IntegrationsMarketplaceHistoryLogsWebComponent";
import {Dependencies, HistoryLogEvents} from "../types";
import {IntegrationsMarketplaceHistoryLogsRepository} from "../repository/IntegrationsMarketplaceHistoryLogsRepository";
import {GzToastNotificationWebComponent} from "../../../ui/gzToastNotification";
import {ToastSeverity} from "../../../ui/gzToastNotification/type";
import {translateFn} from "../../../utils/translator.helper";

export class IntegrationsMarketplaceHistoryLogsController implements ReactiveController {
  private host: IntegrationsMarketplaceHistoryLogsWebComponent;
  private readonly dependencies: Dependencies;
  private dataRepository = new IntegrationsMarketplaceHistoryLogsRepository();

  constructor(host: IntegrationsMarketplaceHistoryLogsWebComponent, dependencies: Dependencies) {
    this.host = host;
    this.dependencies = dependencies;
    this.dataRepository = new IntegrationsMarketplaceHistoryLogsRepository();
    this.dataRepository.injectDependencies(this.dependencies);
    host.addController(this);
    this.host.addEventListener(HistoryLogEvents.CLEAR_LOGS, this.clearLogs.bind(this));
  }

  async hostConnected() {
    await this.getLogs(this.host.integrationId)
  }

  async getLogs(integrationId) {
    this.host.isLoading = true;

    const {logs, success} = await this.dataRepository.getLogs(this.host.integrationId);

    // check if user hasn't switched to another integration
    if (this.host.integrationId !== integrationId) {
      return;
    }

    if (success) {
      this.host.logs = logs;
    } else {
      this.host.logs = [];
      GzToastNotificationWebComponent.buildToastWrapperElement({
        message: translateFn('Could not retrieve integration logs'),
        severity: ToastSeverity.ERROR
      });
    }

    this.host.isLoading = false;
  }

  async clearLogs() {
    const integrationId = this.host.integrationId;
    this.host.isLoading = true;

    const {success} = await this.dataRepository.clearLogs(integrationId)

    // check if user hasn't switched to another integration
    if (integrationId !== this.host.integrationId) {
      return;
    }

    if (success) {
      this.host.logs = [];
    } else {
      GzToastNotificationWebComponent.buildToastWrapperElement({
        message: translateFn('Could not clear integration logs'),
        severity: ToastSeverity.ERROR
      });
    }

    this.host.isLoading = false;
  }
}
